// Feature flags for controlled rollout
export const FEATURE_RUNTIME_SCAN = false;
export const FEATURE_GPT_LOG_CHECK = false; 
export const FEATURE_API_SCAN = false;

// AI Fixer V2 feature flag - controls lean-context system
// TEMPORARILY 100% for testing - will rollback to 25% after verification
export const AI_FIXER_V2 = true; // 100% TESTING: 68% token reduction + 50% faster

// UX Flow feature flag - controls demo-first onboarding
export const SHOW_DEMO_FIRST = true;

// Demo mode flag - controls whether to use mock data vs real API calls
// Set to 'true' for demo/development, 'false' for production
export const DEMO_MODE = import.meta.env.VITE_DEMO_MODE === 'true' || import.meta.env.NODE_ENV === 'development'; 